import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import {
  HiOutlineUserPlus,
  HiOutlinePencilSquare,
  HiOutlineTrash,
  HiOutlineXMark,
  HiOutlineMagnifyingGlass,
  HiOutlineAcademicCap,
  HiOutlineCpuChip,
  HiOutlineChevronLeft,
  HiOutlineChevronRight,
} from "react-icons/hi2";

const API_URL = "https://desarrollotecnologicoar.com/api5";

const Tecnicos = () => {
  const [tecnicos, setTecnicos] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [formDataTecnico, setFormDataTecnico] = useState({
    estatus: "", sucursal: "", nombre_tecnico: "", correo_tecnico: "", telefono: "", puesto: "", nombre_bonos: "",
  });
  const [editingId, setEditingId] = useState(null);
  const [open, setOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("Activo");
  const navigate = useNavigate();

  const fetchTecnicos = async () => {
    try {
      const response = await axios.get(`${API_URL}/tecnicos`);
      setTecnicos(response.data);
    } catch (err) {
      console.error("Error al obtener los tecnicos:", err);
    }
  };

  useEffect(() => { fetchTecnicos(); }, []);

  const handleChange = (e) => setFormDataTecnico({ ...formDataTecnico, [e.target.name]: e.target.value });

  const filteredTecnicos = tecnicos.filter((t) =>
    t.estatus === activeTab &&
    (t.nombre_tecnico.toLowerCase().includes(searchTerm.toLowerCase()) ||
    t.correo_tecnico.toLowerCase().includes(searchTerm.toLowerCase()))
  );

  const totalPages = Math.ceil(filteredTecnicos.length / rowsPerPage);
  const paginatedTecnicos = filteredTecnicos.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  const agregarTecnico = async () => {
    try { await axios.post(`${API_URL}/agregar_tecnico`, formDataTecnico); fetchTecnicos(); handleClose(); }
    catch (err) { console.error("Error al agregar el tecnico:", err); }
  };

  const actualizarTecnico = async () => {
    try { await axios.put(`${API_URL}/actualizar_tecnico/${editingId}`, formDataTecnico); fetchTecnicos(); handleClose(); }
    catch (err) { console.error("Error al actualizar el tecnico:", err); }
  };

  const borrarTecnico = async (id) => {
    try { await axios.delete(`${API_URL}/eliminar_tecnico/${id}`); fetchTecnicos(); }
    catch (err) { console.error("Error al borrar el tecnico:", err); }
  };

  const handleEdit = (tecnico) => { setEditingId(tecnico.id); setFormDataTecnico(tecnico); setOpen(true); };

  const handleOpen = () => {
    setEditingId(null);
    setFormDataTecnico({ estatus: "", sucursal: "", nombre_tecnico: "", correo_tecnico: "", telefono: "", puesto: "", nombre_bonos: "" });
    setOpen(true);
  };

  const handleClose = () => { setOpen(false); setEditingId(null); };

  return (
    <div className="page-container">
      <h1 className="page-title text-center mb-6">Gestion de Tecnicos</h1>

      {/* Search + actions */}
      <div className="flex flex-col sm:flex-row gap-3 mb-4">
        <div className="relative flex-1">
          <HiOutlineMagnifyingGlass className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
          <input type="text" placeholder="Buscar por nombre o correo..." value={searchTerm} onChange={(e) => { setSearchTerm(e.target.value); setPage(0); }} className="input pl-9 py-2 text-sm" />
        </div>
        <button onClick={handleOpen} className="btn-primary text-sm">
          <HiOutlineUserPlus className="w-4 h-4" /> Agregar Tecnico
        </button>
        <button onClick={() => navigate("/panel_control_informacion")} className="text-sm py-2 px-4 inline-flex items-center gap-1.5 bg-purple-600 text-white rounded-btn font-semibold hover:bg-purple-700 transition-colors">
          Supervisar eventos internos
        </button>
      </div>

      {/* Tabs */}
      <div className="flex gap-1 mb-4 border-b border-slate-200">
        {["Activo", "Inactivo"].map((tab) => {
          const count = tecnicos.filter((t) => t.estatus === tab).length;
          return (
            <button
              key={tab}
              onClick={() => { setActiveTab(tab); setPage(0); }}
              className={`px-4 py-2 text-sm font-semibold border-b-2 transition-colors ${
                activeTab === tab
                  ? "border-orange-500 text-orange-600"
                  : "border-transparent text-slate-500 hover:text-slate-700"
              }`}
            >
              {tab}
              <span className={`ml-2 text-xs px-1.5 py-0.5 rounded-full ${
                activeTab === tab ? "bg-orange-100 text-orange-700" : "bg-slate-100 text-slate-500"
              }`}>{count}</span>
            </button>
          );
        })}
      </div>

      {/* Table */}
      <div className="card overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-left">
            <thead>
              <tr className="border-b border-slate-200 bg-slate-50">
                <th className="table-header">Estatus</th>
                <th className="table-header">Sucursal</th>
                <th className="table-header">Nombre</th>
                <th className="table-header">Correo</th>
                <th className="table-header">Telefono</th>
                <th className="table-header">Puesto</th>
                <th className="table-header">Acciones</th>
              </tr>
            </thead>
            <tbody>
              {paginatedTecnicos.map((tec) => (
                <tr key={tec.id} className="border-b border-slate-100 hover:bg-slate-50 transition-colors">
                  <td className="table-cell"><span className={tec.estatus === "Activo" ? "badge-green" : "badge-gray"}>{tec.estatus}</span></td>
                  <td className="table-cell">{tec.sucursal}</td>
                  <td className="table-cell font-medium text-slate-900">{tec.nombre_tecnico}</td>
                  <td className="table-cell text-slate-500">{tec.correo_tecnico}</td>
                  <td className="table-cell">{tec.telefono}</td>
                  <td className="table-cell">{tec.puesto}</td>
                  <td className="table-cell">
                    <div className="flex gap-1">
                      <button onClick={() => handleEdit(tec)} className="btn-ghost text-xs py-1 px-2 text-amber-600 hover:text-amber-700">
                        <HiOutlinePencilSquare className="w-4 h-4" /> Editar
                      </button>
                      <button onClick={() => borrarTecnico(tec.id)} className="btn-ghost text-xs py-1 px-2 text-red-600 hover:text-red-700">
                        <HiOutlineTrash className="w-4 h-4" /> Eliminar
                      </button>
                      <button onClick={() => navigate(`/aptitudes/${tec.id}`)} className="btn-ghost text-xs py-1 px-2 text-purple-600 hover:text-purple-700">
                        <HiOutlineAcademicCap className="w-4 h-4" /> Aptitudes
                      </button>
                      <button onClick={() => navigate(`/competencias?tecnico_id=${tec.id}`)} className="btn-ghost text-xs py-1 px-2 text-blue-600 hover:text-blue-700">
                        <HiOutlineCpuChip className="w-4 h-4" /> Competencias
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
              {paginatedTecnicos.length === 0 && (
                <tr><td colSpan="7" className="text-center py-8 text-slate-400">No se encontraron tecnicos</td></tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <div className="flex items-center justify-between px-4 py-3 border-t border-slate-200 text-sm text-slate-600">
          <div className="flex items-center gap-2">
            <span>Filas por pagina:</span>
            <select value={rowsPerPage} onChange={(e) => { setRowsPerPage(Number(e.target.value)); setPage(0); }} className="border border-slate-200 rounded px-2 py-1 text-sm">
              {[10, 25, 50].map((n) => <option key={n} value={n}>{n}</option>)}
            </select>
          </div>
          <div className="flex items-center gap-2">
            <span>{page * rowsPerPage + 1}-{Math.min((page + 1) * rowsPerPage, filteredTecnicos.length)} de {filteredTecnicos.length}</span>
            <button onClick={() => setPage(Math.max(0, page - 1))} disabled={page === 0} className="btn-icon disabled:opacity-30"><HiOutlineChevronLeft className="w-4 h-4" /></button>
            <button onClick={() => setPage(Math.min(totalPages - 1, page + 1))} disabled={page >= totalPages - 1} className="btn-icon disabled:opacity-30"><HiOutlineChevronRight className="w-4 h-4" /></button>
          </div>
        </div>
      </div>

      {/* Add/Edit Modal */}
      {open && (
        <>
          <div className="overlay" onClick={handleClose} />
          <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
            <div className="modal w-full max-w-lg max-h-[90vh] overflow-y-auto">
              <div className="flex items-center justify-between mb-4">
                <h3 className="text-lg font-semibold text-slate-900">{editingId ? "Editar Tecnico" : "Agregar Tecnico"}</h3>
                <button onClick={handleClose} className="btn-icon"><HiOutlineXMark className="w-5 h-5" /></button>
              </div>
              <div className="space-y-3">
                <div>
                  <label className="label">Estatus</label>
                  <select name="estatus" value={formDataTecnico.estatus} onChange={handleChange} className="input">
                    <option value="">-- Selecciona --</option>
                    <option value="Activo">Activo</option>
                    <option value="Inactivo">Inactivo</option>
                  </select>
                </div>
                <div>
                  <label className="label">Sucursal</label>
                  <select name="sucursal" value={formDataTecnico.sucursal} onChange={handleChange} className="input">
                    <option value="">-- Selecciona --</option>
                    {["CDMX", "Luis Molina", "Españoles", "8 de Julio", "Ocotlan", "Monterrey", "San Luis Potosí"].map((s) => <option key={s} value={s}>{s}</option>)}
                  </select>
                </div>
                {[
                  { name: "nombre_tecnico", label: "Nombre Tecnico", type: "text" },
                  { name: "correo_tecnico", label: "Correo Tecnico", type: "email" },
                  { name: "telefono", label: "Telefono", type: "tel" },
                  { name: "puesto", label: "Puesto", type: "text" },
                  { name: "nombre_bonos", label: "Nombre de Bonos", type: "text" },
                ].map((field) => (
                  <div key={field.name}>
                    <label className="label">{field.label}</label>
                    <input type={field.type} name={field.name} value={formDataTecnico[field.name]} onChange={handleChange} className="input" />
                  </div>
                ))}
              </div>
              <div className="flex justify-end gap-2 mt-6">
                <button onClick={handleClose} className="btn-secondary">Cancelar</button>
                <button onClick={editingId ? actualizarTecnico : agregarTecnico} className="btn-primary">
                  {editingId ? "Actualizar" : "Agregar"}
                </button>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default Tecnicos;
